'use strict'

var F = require('functionally')

module.exports = F.curry(function(re, value){
    return !!re.test(value)
})


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/is/match.js
 ** module id = 834
 ** module chunks = 0
 **/